import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
// import 'react-select/dist/react-select.css';
import App from './App';
// import('react-scan');        
// import('react-grab');   

import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "./reducers/index";
import theme from "./theme/index"
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import 'semantic-ui-css/semantic.css';

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)));
// if (window.localStorage.getItem("accessToken")) {
//   const user = window.localStorage.getItem("accessToken");
//   axios
//     .post("/api/auth/me", { token: JSON.parse(user) })
//     .then((user) => {
//       store.dispatch(SignIn(user.data));
//       // store.dispatch(setBasicCompanyId(user.data.company));
//     })
//     .catch((error) => {
//       console.log(error.response);
//     });
// }
// *****************

// Suppress generic "Script error." from cross-origin scripts (ad blockers, GTM, Hotjar)
window.addEventListener('error', (event) => {
  if (event.message === 'Script error.') {
    event.preventDefault();
    event.stopPropagation();
  }
});

console.warn('store data', store);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      {/* {localStorage.authUser && */}
      <BrowserRouter>
      <ThemeProvider theme={theme}>
      <CssBaseline />
      <React.Profiler>
        <App />
      </React.Profiler>

      </ThemeProvider>
      </BrowserRouter>
      {/* } */}
    </Provider>
  // </React.StrictMode>
);
